/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Delete_QInputs */



/**
* | output |
* | --- |
* | "Can I delete an account or change my email address?" |
*
* @param {Partner_Faq_Delete_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_delete_q = /** @type {((inputs?: Partner_Faq_Delete_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Delete_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kann ich ein Konto löschen oder meine E-Mail-Adresse ändern?")
	return /** @type {LocalizedString} */ ("Can I delete an account or change my email address?")
});